module.exports = __webpack_public_path__ + "img/cold_sweat.fcd22701.png";